import React, { Component } from "react";
import { Select } from "antd";
import { bindActionCreators } from "redux";
import { setLanguage } from "../actions/CommonActions";
import { connect } from "react-redux";
import { setSelectedLanguage } from "../utils/LocalStore";
import { availableLanguages } from "../utils/translations";
import "../styles/languageSelector.css";
import en_flag from "../assets/images/flags/en.png";
import es_flag from "../assets/images/flags/es.png";
import ca_flag from "../assets/images/flags/ca.png";
import pt_flag from "../assets/images/flags/pt.png";
import fr_flag from "../assets/images/flags/fr.png";
import nl_flag from "../assets/images/flags/nl.png";

const { Option } = Select;
const flags = {
  ca: ca_flag,
  en: en_flag,
  es: es_flag,
  pt: pt_flag,
  fr: fr_flag,
  nl: nl_flag,
};

class LanguageSelector extends Component {
  onChange = (value) => {
    this.props.setLanguage(value);
    setSelectedLanguage(value);
  };

  render() {
    return (
      <div className="language-selector">
        <Select
          showSearch={false}
          style={{ width: "130px" }}
          value={this.props.selectedLanguage}
          onChange={this.onChange}
        >
          {availableLanguages.map((data) => {
            return (
              <Option value={data.code} key={data.code}>
                <img src={flags[data.code]} alt="" />
                {data.name}
              </Option>
            );
          })}
        </Select>
      </div>
    );
  }
}

const mapsStateToProps = (state) => {
  return {
    selectedLanguage: state.common.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setLanguage,
    },
    dispatch
  );
};

export default connect(mapsStateToProps, mapDispatchToProps)(LanguageSelector);
